import { render, staticRenderFns } from "./EventHeaderCard.vue?vue&type=template&id=411cfe96"
import script from "./EventHeaderCard.vue?vue&type=script&lang=js"
export * from "./EventHeaderCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports